module.exports = __webpack_public_path__ + "img/left-mole.b38e6677.png";